module.exports = __webpack_public_path__ + "static/media/basketball.11fdca82.svg";